import React, { useEffect, useReducer, useState } from 'react'
import { Button } from '@/Components/ui/button'
import Datatable from '@/Components/Common/Datatable'
import { Input } from '@/Components/ui/input'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDebounce } from 'use-debounce'
import Constant from '@/utils/Constant'
import HeaderCard from '@/Components/HeaderCard'
import BodyCard from '@/Components/BodyCard'
import { SquarePlus } from 'lucide-react'
import DataTableEnumType from '@/Enums/DataTableTypeEnum'
import { useAuth } from '@/Context/AuthContext'
import RequiredPermission from '@/assets/data/RequiredPermission'
import { checkPermission } from '@/utils/helper'
import DeleteConfirmationTypeEnum from '@/Enums/DeleteConfirmationTypeEnum'
import ConfirmationPopup from '@/Components/Common/ConfirmationPopup'

import ShiftTypeService from '@/Service/ShiftTypeService'
import ShiftTypeColumn from './ShiftTypeColumn'
const ShiftType = () => {
    const { userInfo } = useAuth()
    const navigate = useNavigate()

    const [event, updateEvent] = useReducer((prev, next) => ({ ...prev, ...next }), {
        totalshiftCount: 0,
        isDataFetching: false,
        deleteConfirmationOpen: false,
        shift_types: [],
        deleteId: [],
        allcheck: false,
        shiftSearch: '',
        isOpen: false,
        queryParam: {
            page: 1,
            shift_name: '',
        },
    })
    const [debouncedshiftSearch] = useDebounce(event.shiftSearch, Constant.DEBOUNCE_DELAY)
    const location = useLocation()
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false)
    const getShiftType = async (page = 1) => {
        updateEvent({ isDataFetching: true, shift_types: [] })
        try {
            const resp = await ShiftTypeService.getShiftTypes(event.queryParam)
            if (resp.data.success) {
                updateEvent({ shift_types: resp.data.data, totalshiftCount: resp.data.pagination.total_record })
            }
        } catch (err) {}
        updateEvent({ isDataFetching: false })
    }
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const page = parseInt(searchParams.get('page') || 1)
        updateEvent({
            queryParam: {
                ...event.queryParam,
                page,
            },
        })
    }, [location.search])

    useEffect(() => {
        console.log('sections')
        getShiftType()
    }, [event.queryParam.page, event.queryParam.shift_name])

    useEffect(() => {
        updateEvent({
            queryParam: {
                ...event.queryParam,
                shift_name: debouncedshiftSearch,
            },
        })
    }, [debouncedshiftSearch])

    const createClient = () => {
        navigate(`/setup/shift-type/new`)
    }

    const deleteShiftType = async (action) => {
        if (!action) {
            updateEvent({ deleteConfirmationOpen: false })
            return false
        }
        try {
            const resp = await ShiftTypeService.deleteShiftType(event.deleteId)
            if (resp.data.success) {
                getShiftType()
            }
            updateEvent({ deleteId: [], allcheck: false })
        } catch (err) {}
        updateEvent({ deleteConfirmationOpen: false })
    }
    return (
        <div>
            <HeaderCard>
                <div className="flex justify-between items-center">
                    {checkPermission(RequiredPermission.PROCESS.CREATE, userInfo.roles) && (
                        <Button className="bg-primary-btn hover:bg-primary-purpal" onClick={createClient}>
                            <SquarePlus />
                            Add New Shift Type
                        </Button>
                    )}

                    {checkPermission(RequiredPermission.PROCESS.DELETE, userInfo.roles) && event.deleteId.length > 0 && (
                        <Button
                            variant="outline"
                            onClick={() => updateEvent({ deleteConfirmationOpen: true })}
                            className={`ml-[10px] ${event.deleteId.length > 0 ? 'block' : 'hidden'}`}
                        >
                            Delete
                        </Button>
                    )}
                </div>
            </HeaderCard>
            <ConfirmationPopup
                open={event.deleteConfirmationOpen}
                message="Are you sure you want to delete this permanently?"
                type={DeleteConfirmationTypeEnum.DELETE}
                setOpen={() => updateEvent({ deleteConfirmationOpen: !event.deleteConfirmationOpen })}
                handleAction={deleteShiftType}
            />
            <BodyCard>
                <div className="w-full my-2 grid grid-cols-4 gap-3">
                    <Input
                        type="text"
                        value={event.shift_name}
                        onChange={(e) => updateEvent({ shiftSearch: e.target.value })}
                        placeholder="Shift Name"
                    />
                </div>
                <Datatable
                    columns={ShiftTypeColumn()}
                    data={event.shift_types}
                    totalDataCount={event.totalshiftCount}
                    allcheck={event.allcheck}
                    deleteId={event.deleteId}
                    updateEvent={updateEvent}
                    loading={event.isDataFetching}
                    type="SHIFT_TYPE"
                />
            </BodyCard>
        </div>
    )
}

export default ShiftType
